import { useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Box,
  Stack,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";

//project components

import config from "../../../../config";
import PaymentForm from "./PaymentForm";
import { useSelector } from "react-redux";
import {
  convertDateToLocal,
  convertDateToLocalReverse,
} from "../../../../utils/date-operations";

const Payment = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const { payments, onSave, candidateId } = props;
  const { userId, profileId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState({
    id: 0,
    candidateId: candidateId,
    date: convertDateToLocalReverse(new Date()),
    paymentMode: "",
    paymentGatewayId: "",
    amount: 0,
    paymentType: 1,
    details: "",
  });

  //Methods
  const handleAdd = () => {
    setSelectedPayment({
      id: 0,
      candidateId: candidateId,
      date: convertDateToLocalReverse(new Date()),
      paymentMode: "Cash",
      paymentGatewayId: "",
      amount: 0,
      paymentType: 1,
      details: "",
    });
    setOpenAdd(true);
  };

  const handleDelete = () => {
    axiosAuth
      .delete("/api/CandidatePayments/" + selectedPayment.id)
      .then((response) => {
        onSave();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };

  const handleSave = () => {
    onSave();
    setOpenAdd(false);
  };

  const handleCancel = () => {
    setOpenAdd(false);
  };

  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Payments
            </Typography>
          </Grid>
          {role !== 4 && (
            <Grid item>
              <IconButton onClick={handleAdd}>
                <AddIcon sx={{ color: "#ffffff" }} />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {payments && payments?.length > 0 ? (
            payments.map((payment, index) => {
              return (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 1,
                    paddingX: 1,
                    paddingY: 2,
                    // display: "flex",
                    // justifyContent: "space-between",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography>
                      <b>Payment Date:</b>
                      {convertDateToLocal(payment.date)}
                    </Typography>
                    <Typography>
                      <b>Amount:</b> {payment.amount?.toFixed(2)}
                    </Typography>
                    <Typography>
                      <b>Payment Mode:</b> {payment.paymentMode}
                    </Typography>
                    <Typography>
                      <b>Payment Type:</b> {payment.paymentTypeDisplay}
                    </Typography>
                    <Typography>
                      <b>Details:</b> {payment.details}
                    </Typography>
                  </Stack>
                  {role !== 4 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Stack
                        // alignItems="center"
                        // justifyContent="center"
                        // spacing={2}
                        direction="row"
                      >
                        <IconButton
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => {
                            setSelectedPayment(payment);
                            setOpenAdd(true);
                          }}
                        >
                          <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setSelectedPayment(payment);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        <Typography>{index + 1}</Typography>
                      </Stack>
                    </>
                  )}
                </Card>
              );
            })
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No payments data available
              </Typography>
            </Box>
            // <NoDataFound />
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          {payments && payments?.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 40 }}>#</TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Payment Date
                    </TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Amount
                    </TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Payment Mode
                    </TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Payment Type
                    </TableCell>
                    <TableCell align="left">Details</TableCell>
                    <TableCell align="right" sx={{ width: 90 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payments.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">
                        {convertDateToLocal(row.date)}
                      </TableCell>
                      <TableCell align="left">
                        {row.amount?.toFixed(2)}
                      </TableCell>
                      <TableCell align="left">{row.paymentMode}</TableCell>
                      <TableCell align="left">
                        {row.paymentTypeDisplay}
                      </TableCell>
                      <TableCell align="left">{row.details}</TableCell>
                      <TableCell align="right">
                        {role !== 4 && (
                          <>
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedPayment(row);
                                setOpenAdd(true);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedPayment(row);
                                setOpenDelete(true);
                              }}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No payments data available
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <PaymentForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedPayment={selectedPayment}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Payment</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the payment of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedPayment?.candidateName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default Payment;
